@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/color-helpers.scss';

:host {
  background-color: var(--white-layout-302-level-1-elevation);
  color: var(--main-titles-inputs-600);
}

.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;

  .widget-title {
    margin-bottom: 0;
    height: 100%;

    .title-icon {
      transform: scale(0);
      transition: all 0.1s ease-in-out;
      margin-left: var(--spacer);
    }
  }

  &:not(.is-error):not(.is-empty):not(.is-loading) {
    .widget-title {
      &.has-action {
        cursor: pointer;

        &:hover,
        &:focus,
        &:active {
          .title-icon {
            transform: scale(1);
          }
        }

        &:hover {
          color: var(--blue-layout-300-active);
        }

        &:focus {
          color: var(--blue-layout-500-focus);
        }

        &:active {
          color: var(--blue-layout-300-active);
        }
      }
    }

    .item--title,
    .item--value {
      &.has-action {
        &.drilldown-binder-hover {
          cursor: pointer;
          transition: color 0.3s ease-in-out;
          color: var(--blue-layout-301-active);
        }

        &.drilldown-binder-focus {
          cursor: pointer;
          transition: color 0.3s ease-in-out;
          color: var(--blue-layout-500-focus);
        }

        &.drilldown-binder-active {
          cursor: pointer;
          transition: color 0.3s ease-in-out;
          color: var(--blue-layout-300-active);
        }
      }
    }
  }

  &.is-error,
  &.is-empty {
    .inventory {
      .inventory-block {
        .item {
          &.has-action {
            cursor: default;
            pointer-events: none;
          }
        }
      }
    }
  }
}

.content {
  flex: 1;
}

#inventoryTitle {
  line-height: 20px;
}

.inventory {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 var(--spacer);
  font-size: var(--body-size);
  height: 100%;
  position: relative;

  .divider {
    height: 80%;
    width: 1px;
    background: var(--chart-101-pressed-dividers);
  }

  .inventory-block {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
    height: 20px;
    width: 100%;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      justify-content: center;
    }
    .item-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    &.is-loading {
      .item {
        opacity: 0;
      }
    }

    .widget-loading {
      width: calc(100% - calc(var(--spacer) * 2.5));
      height: 24px;
      top: 0;
      bottom: 0;
      margin: 0 auto;
    }
  }

  .item {
    &--title {
      padding-right: var(--spacer);
    }

    &--icon {
      span {
        &:before {
          font-size: 20px;
          vertical-align: middle;
          color: var(--chart-302-icon-buttons-titles);
        }
      }

      &--label {
        font-size: var(--body-size);
        padding-left: 12px;
        vertical-align: middle;
        padding-top: 2px;
      }
    }

    &--value {
      font-weight: bold;
      color: var(--main-titles-inputs-600);
    }

    &--value,
    &--delta {
      font-family: var(--font-family-secondary-mono);
    }

    &--delta {
      font-weight: bold;

      &:not(:empty) {
        &:before {
          content: '/';
          color: var(--main-titles-inputs-600);
        }
      }

      &.success {
        color: var(--green-layout-101-primary-green);
      }

      &.danger {
        color: var(--red-layout-300-primary);
      }
    }
  }
  .item--icon {
    .ds-icon-entity_endpoint {
      &:before {
        font-size: 30px;
      }
    }
  }
}

#inventory {
  #virtualMachinesIcon,
  #physicalEndpointsIcon,
  #linuxIcon,
  #macOSIcon,
  #winServersIconLabel,
  #winServersIcon,
  #winWorkstationsIconLabel,
  #winWorkstationsIcon,
  .item[gz-inventory='containerHosts'],
  .item[gz-inventory='containers'] {
    display: flex;
  }

  #containersIcon,
  #containerHostsIcon,
  #dividerBeforeContainerHosts,
  .item[gz-inventory='containerHosts'],
  .item[gz-inventory='containers'] {
    display: none;
  }

  #winWorkstationsName,
  #winServersName,
  #macOSName,
  #linuxName,
  #physicalEndpointsName,
  #virtualMachinesName,
  #containersName,
  #containerHostsName {
    display: none;
  }

  &.show-containers {
    #containersIcon,
    #containerHostsIcon,
    #dividerBeforeContainerHosts,
    .item[gz-inventory='containerHosts'],
    .item[gz-inventory='containers'] {
      display: flex;
    }
  }
}

// TBD: responsive styles
@media screen and (max-width: 1600px) {
  .inventory {
    .inventory-block {
      padding-left: calc(2 * var(--spacer));
      padding-right: calc(2 * var(--spacer));
    }
  }
}

@media screen and (max-width: 1366px) {
  .inventory {
    .inventory-block {
      padding-left: calc(2 * var(--spacer));

      .item {
        flex-wrap: wrap;
        justify-content: flex-start;

        &--title {
          width: 100%;
          align-self: flex-start;
          margin-right: 0;
          line-height: 1;
        }

        &--value,
        &--delta {
          align-self: flex-end;
        }
      }
    }

    &.show-containers {
      .item {
        &--title {
          width: auto !important;
        }
        &--value,
        &--delta {
          align-self: auto !important;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .wrapper {
    flex-direction: column;
  }
}
.inventory .inventory-block .item {
  height: auto;
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .content {
      .inventory {
        .item {
          .item-name {
            display: block !important;
            font-size: 10px;
          }
          #physicalEndpointsIconName {
            max-height: 20px;
          }
          #physicalEndpointsIcon {
            margin-top: -5px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .wrapper {
      flex-direction: row;
    }
  }

  @media screen and (max-width: 1600px) {
    .inventory .inventory-block {
      padding-left: 0;
      padding-right: 0;
    }
  }

  @media screen and (max-width: 1366px) {
    .inventory .inventory-block .item--title {
      align-self: center;
      width: auto;
      line-height: normal;
    }
  }
}

@media screen and (min-width: 2559px) {
  #inventory {
    #virtualMachinesIcon,
    #physicalEndpointsIcon,
    #linuxIcon,
    #macOSIcon,
    #winServersIconLabel,
    #winServersIcon,
    #winWorkstationsIconLabel,
    #winWorkstationsIcon,
    #containersIcon,
    #containerHostsIcon,
    .item[gz-inventory='containerHosts'],
    .item[gz-inventory='containers'] {
      padding-right: var(--spacer);
    }

    #winWorkstationsName,
    #winServersName,
    #macOSName,
    #linuxName,
    #physicalEndpointsName,
    #virtualMachinesName {
      display: flex;
    }

    &.show-containers {
      #containersName,
      #containerHostsName {
        display: flex;
      }
    }

    .item--title {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  gz-tooltip {
    pointer-events: none;
  }
}
